var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#BFC6D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.836 33H69.5733C70.8197 33 71.8301 34.0104 71.8301 35.2568V61.0825C71.8301 62.3289 70.8197 63.3394 69.5733 63.3394H40.836C39.5896 63.3394 38.5792 62.3289 38.5792 61.0825V35.2568C38.5792 34.0104 39.5896 33 40.836 33Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6037 34V45.1241C51.5931 45.2094 51.6097 45.2958 51.6512 45.3711C51.6927 45.4464 51.7569 45.5066 51.8347 45.5432C51.9125 45.5797 51.9999 45.5908 52.0843 45.5747C52.1687 45.5586 52.2459 45.5163 52.3048 45.4537L55.301 42.2538C55.3375 42.2098 55.3833 42.1744 55.4351 42.1501C55.4869 42.1257 55.5434 42.1131 55.6006 42.1131C55.6578 42.1131 55.7143 42.1257 55.7661 42.1501C55.8179 42.1744 55.8637 42.2098 55.9002 42.2538L58.8964 45.4537C58.9553 45.5163 59.0325 45.5586 59.1169 45.5747C59.2013 45.5908 59.2887 45.5797 59.3665 45.5432C59.4442 45.5066 59.5085 45.4464 59.55 45.3711C59.5915 45.2958 59.6081 45.2094 59.5975 45.1241V34H51.6037Z",
    fill: "#5F768C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.599 58.5767C58.7742 58.5767 56.4842 60.8667 56.4842 63.6914C56.4842 66.5162 58.7742 68.8073 61.599 68.8073C64.4237 68.8073 66.7148 66.5162 66.7148 63.6914C66.7148 60.8667 64.4248 58.5767 61.599 58.5767ZM23.2333 58.5767C20.4085 58.5767 18.1185 60.8667 18.1185 63.6914C18.1185 66.5162 20.4085 68.8073 23.2333 68.8073C26.058 68.8073 28.3481 66.5162 28.3481 63.6914C28.3481 60.8667 26.058 58.5767 23.2333 58.5767Z",
    fill: "#BFC6D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 56.0166V63.6904H18.1159C18.1159 60.8657 20.4059 58.5756 23.2306 58.5756C26.0554 58.5756 28.3454 60.8657 28.3454 63.6904H38.5771V50.9019H18.1159C15.3029 50.9019 13 53.2037 13 56.0166Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2316 50.9021H38.5781V40.6704H30.9054C26.6672 40.6704 23.2316 50.9021 23.2316 50.9021Z",
    fill: "#BFC6D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8301 43.5V63.6907H66.7153",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5791 40.6727V35.5579C38.5791 34.1509 39.73 33 41.1381 33H69.2731C70.6791 33 71.8311 34.1498 71.8311 35.5579V38.1116",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4824 63.6904H38.5769",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5771 50.9021V40.6704H30.9044C26.6662 40.6704 23.2306 50.9021 23.2306 50.9021M38.5771 50.9021H18.1159C15.3029 50.9021 13 53.2039 13 56.0169V63.6907H18.1159M38.5771 50.9021V63.6907H28.3454",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1174 63.6914C18.1174 66.5162 20.4074 68.8073 23.2322 68.8073C26.057 68.8073 28.347 66.5162 28.347 63.6914C28.347 60.8667 26.057 58.5767 23.2322 58.5767C20.4074 58.5767 18.1174 60.8667 18.1174 63.6914ZM56.4842 63.6914C56.4842 66.5162 58.7742 68.8073 61.599 68.8073C64.4237 68.8073 66.7148 66.5162 66.7148 63.6914C66.7148 60.8667 64.4248 58.5767 61.599 58.5767C58.7732 58.5767 56.4842 60.8667 56.4842 63.6914Z",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8003 43.1846H80.4824",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7016 50.3467H80.8018",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4021 50.3467H86.5186",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3912 57.5049H87.3799",
    stroke: "#5F768C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6006 32.5C62.6006 36.6421 65.9585 40 70.1006 40C74.2427 40 77.6006 36.6421 77.6006 32.5C77.6006 28.3579 74.2427 25 70.1006 25C65.9585 25 62.6006 28.3579 62.6006 32.5Z",
    fill: "#5F768C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3506 29.5C69.3506 29.0858 69.6864 28.75 70.1006 28.75C70.5148 28.75 70.8506 29.0858 70.8506 29.5V31.75H73.1006C73.5148 31.75 73.8506 32.0858 73.8506 32.5C73.8506 32.9142 73.5148 33.25 73.1006 33.25H70.8506V35.5C70.8506 35.9142 70.5148 36.25 70.1006 36.25C69.6864 36.25 69.3506 35.9142 69.3506 35.5V33.25H67.1006C66.6864 33.25 66.3506 32.9142 66.3506 32.5C66.3506 32.0858 66.6864 31.75 67.1006 31.75H69.3506V29.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingorders);
export default __webpack_public_path__ + "static/media/upcomingorders.fa08c278dd60acb78ee2a3187bff878d.svg";
export { ForwardRef as ReactComponent };